import type { ChargingStation } from "../config/amapChargingDemo";
import type { CabinState } from "../types/domain";

// AMap POIs contain location, not live tariff or stall inventory.
// Keep simulated operational facts identical in controls, decisions and cards.
export function applyChargingControlFacts(
  stations: ChargingStation[],
  state: Pick<CabinState, "chargerAvailability" | "chargerPrice">
): ChargingStation[] {
  return stations.map((station) => ({
    ...station,
    availableStalls: state.chargerAvailability,
    pricePerKwh: state.chargerPrice
  }));
}
